import React, { useState } from "react";
import "./FloatingButton.css";
import ReplyIcon from "@mui/icons-material/Reply";
import Tooltip from "@mui/material/Tooltip";
import ScreenShot from "../../images/SupportIcon.svg";
import CloseIcon from "../../images/Close.png";
import tickets from "../../images/tickets.png";
import useScreenRecorder from "../../hooks/useScreenRecorder";

const FloatingButton = ({
  setType,
  handleRecordFlow,
  showFloat,
  setShowFloat,
  setShowRecordModal,
  showRecordModal,
  parentStyle,
  select,
  setSelect
}) => {
  const {
    startRecording,
    pauseRecording,
    blobUrl,
    resetRecording,
    resumeRecording,
    stopRecording,
    status,
    setStatus
  } = useScreenRecorder({ audio: true });

  const [isOpen, setIsOpen] = useState(false);
  const [showFloatingButton, setShowFloatingButton] = useState(true);
  const [isClicked, setIsClicked] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleReplyClick = () => {
    setShowFloatingButton((prev) => {
      return !prev;
    });
    setIsClicked(false);
  };

  const handleButtonClick = () => {
    if (isOpen) {
      setType("shotType");
      setIsOpen(false);
      setSelect(true);
    } else {
      setType("none");
      setIsOpen(true);
    }
  };

  const handleClick = () => {
    if (isOpen) {
      setIsOpen(false);
      setSelect(true);
      setShowFloatingButton(false);
    } else {
      setType("none");
      setIsOpen(true);
    }
    setIsClicked(true);
  };

  const handleRecordClick = () => {
    setIsOpen(false);
    setStatus("permission-required");
    setShowRecordModal(true);
    handleRecordFlow();
    setSelect(false);
    setShowFloatingButton(false);
  };

  const handleCross = () => {
    setType("none");
    setIsOpen(false);
    setShowFloatingButton(true);
    setIsClicked(false);
  };

  return (
    <div
      className='floatingButtonContainer'
      style={{ ...parentStyle.customIndex }}
    >
      {!showFloatingButton && (
        <Tooltip title='Show Support Icon' placement='top' arrow>
          <div
            className={`replicon ${showFloatingButton ? "rotated" : ""}`}
            onClick={handleReplyClick}
          >
            <ReplyIcon style={{ fontSize: "2rem", color: "grey" }} />
          </div>
        </Tooltip>
      )}
      {showFloatingButton && (
        <>
          <div
            className={`floatingButton ${isClicked ? "no-hover" : ""}`}
            style={{ ...parentStyle.customIndex }}
            onMouseEnter={() => {
              return setIsHovered(true);
            }}
            onMouseLeave={() => {
              return setIsHovered(false);
            }}
            onClick={() => {
              return isHovered && handleClick();
            }}
          >
            <div className='FloatingIcon'>
              {isOpen ? (
                <img
                  onClick={handleCross}
                  src={CloseIcon}
                  alt='Close'
                  width='30px'
                />
              ) : (
                <img src={ScreenShot} alt="Support" />
              )}
            </div>
            {isOpen && (
              <div
                className='FloatingModal'
                style={{ ...parentStyle.customIndex }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        marginTop: "16px",
                        fontSize: "16px",
                        fontWeight: "500",
                        textAlign: "left"
                      }}
                    >
                      Facing Problem?
                    </div>
                    <div style={{ fontSize: "14px", textAlign: "left" }}>
                      Our web support team is here to help! Feel free to reach
                      out to with any question or issues you're facing while
                      navigating our website.
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        textAlign: "left"
                      }}
                    >
                      Report an issue
                    </div>
                  </div>
                  <div>
                    <img
                      src={tickets}
                      style={{ width: "155px", height: "155px" }}
                      alt=''
                    />
                  </div>
                </div>
                <div style={{ paddingRight: "32px" }}>
                  <div
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "white",
                      width: "100%",
                      margin: "16px 0px 0px 0px ",
                      borderRadius: "8px",
                      textAlign: "center",
                      padding: "8px",
                      backgroundColor: "#0F4C81"
                    }}
                    onClick={handleButtonClick}
                  >
                    Take A Screenshot
                  </div>
                  <div
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "white",
                      width: "100%",
                      margin: "16px 0px 0px 0px ",
                      borderRadius: "8px",
                      textAlign: "center",
                      padding: "8px",
                      backgroundColor: "#0F4C81"
                    }}
                    onClick={handleRecordClick}
                  >
                    Record A Video
                  </div>
                </div>
              </div>
            )}
            <div className='floatingButtonText'>Report An Issue</div>
          </div>
          <div
            className={`replicon ${showFloatingButton ? "rotated" : ""}`}
            onClick={handleReplyClick}
          >
            <Tooltip title='Hide Support Icon' placement='top' arrow>
              <ReplyIcon style={{ fontSize: "2rem", color: "grey" }} />
            </Tooltip>
          </div>
        </>
      )}
    </div>
  );
};

export default FloatingButton;
